export const FEATURE_TOGGLE = {
  enable_website_banner: true,
  enable_docsnav_banner: true,
  enable_job_banner: false,
};
